import { html } from "lit";
var icon_lock_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M16 2a7 7 0 016.995 6.738L23 9v3.5h.875a2.626 2.626 0 012.62 2.459l.005.166v12.25A2.625 2.625 0 0123.875 30H8.125A2.625 2.625 0 015.5 27.375v-12.25A2.625 2.625 0 018.125 12.5H9V9a7 7 0 017-7zm7.875 12.25H8.125a.875.875 0 00-.875.875v12.25c0 .483.392.875.875.875h15.75a.875.875 0 00.875-.875v-12.25a.875.875 0 00-.875-.875zM16 18.625c.443 0 .81.33.867.756l.008.119V23a.875.875 0 01-1.742.119L15.125 23v-3.5c0-.483.392-.875.875-.875zM16 3.75a5.25 5.25 0 00-5.244 5.003L10.75 9v3.5h10.5V9c0-2.9-2.35-5.25-5.25-5.25z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_lock_default as default
};
//# sourceMappingURL=icon-lock.js.map
